module.exports = __webpack_public_path__ + "static/media/Samsung Galaxy Grand Prime White.fcea7e83.png";